import React, { FC } from 'react';
import { EvidenceItem as EvidenceItemType } from '../NewVerificationTab.data';
import { EvidenceStack, EvidenceItem, EvidenceValue, EvidenceSource, EvidenceTypeLabel } from '../NewVerificationTab.styles';

interface EvidenceDisplayProps {
  evidence: React.ReactNode | EvidenceItemType[];
}

export const EvidenceDisplay: FC<EvidenceDisplayProps> = ({ evidence }) => {
  if (Array.isArray(evidence)) {
    if (evidence.length === 0) {
      return <span>-</span>;
    }
    return (
      <EvidenceStack>
        {evidence.map((item, idx) => (
          <EvidenceItem key={idx}>
            <EvidenceValue>{item.value}</EvidenceValue>
            {item.source && <EvidenceSource>{item.source}</EvidenceSource>}
            {item.evidenceType && <EvidenceTypeLabel>({item.evidenceType})</EvidenceTypeLabel>}
          </EvidenceItem>
        ))}
      </EvidenceStack>
    );
  }
  // Show "-" for empty/null/undefined evidence
  if (!evidence || evidence === '') {
    return <span>-</span>;
  }
  return <span>{evidence}</span>;
};
